<template>
    <app-layout>

            <div class="flex w-full md:w-2/3 lg:w-1/2 bg-white flex-col gap-7 border-t-4 border-gray-600 px-24 pt-4 sm:pt-12 pb-14 mx-auto text-center">
                <h2 class="py-8">{{ title }}</h2>

                <div
                    v-show="step == 0"
                    class="text-left"
                >
                    <div class="pb-6 uppercase">{{ user.email }}</div>

                    <v-flex flex-column>
                        <v-text-field
                            label="New password"
                            v-model="user.password"
                            outlined
                            dense
                            background-color="white"
                            type="password"
                        />
                    </v-flex>
                    <v-flex flex-column>
                        <v-text-field
                            label="Confirm new password"
                            v-model="user.password_confirmation"
                            outlined
                            dense
                            background-color="white"
                            type="password"
                        />
                    </v-flex>
                    <v-btn
                        class="btn btn-solid"
                        color="primary"
                        dark
                        @click="saveChanges"
                    >
                        CONFIRM
                    </v-btn>
                </div>

                <div v-show="step == 'last'">
                    <h4 class="text-md mb-5">
                        After first login, you'll need to configure the ELCC 2FA security.
                    </h4>

                    <v-btn class="edit-button" elevation="0" :class="{ 'opacity-25': enabling }" :disabled="enabling" @click="login">
                        Continue to Login
                    </v-btn>
                </div>

            </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    components: {
        AppLayout,
    },

    props: {
        'input': {
            // Current user
            type: Object,
            required: true,
            default: function () {
                return undefined
            }
        },
        'token': {
            // Email token
            type: String,
            required: true,
            default: function () {
                return undefined
            }
        },
    },

    data() {
        return {
            title: 'Set your account password',
            user: this.input || null,
            enabling: false,
            disabling: false,
            showConfirmation: false,
            show2fasteps: false,
            step: 0,
            twoFactorCode: null,
            enableForm: {
                mobilePhone: null,
            },
        }
    },

    methods: {
        saveChanges() {
            let payload = {
                token:      this.token,
                email:      this.user.email,
                password:   this.user.password,
                password_confirmation: this.user.password_confirmation,
            }
            let url = route('password.store', this.token).url()
            let method = 'post'

            axios({
                method: method,
                url: url,
                data: payload
            })
            .then((response)=>{
                if (!response.data.error) {
                    this.$root.is_dirty = false
                    this.title = '2FA Configuration Required'
                    this.step = 'last'
                    this.$root.snackbar.success("Password saved with success")
                    /*setTimeout(() => {
                        window.location.replace('/login')
                    }, 2000)*/
                    this.showAskPhone = true
                }
                else {
                    if(response.data.error) {
                        throw (response.data.error)
                    }
                    throw ('Unknow error have canceled this request.')
                }
            }).catch((error) => {
                this.errorHandler(error)
            })
        },

        login() {
            this.enabling = true
            window.location.replace('/login')
        },

        errorHandler(error) {
            if( error.response?.data && typeof error.response.data.errors === 'object'){
                var errorDetail = Object.values(error.response.data.errors)[0][0]
                this.$root.snackbar.error(errorDetail)
            }
            else {
                this.$root.snackbar.error(error)
            }
            console.log(error)

        },
    },
}
</script>

<style scoped>
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.shadow {

}
.primary-button {
    margin: 0.25rem;
    margin-top: 1.75rem;
    display: block;
    cursor: pointer;
    border-radius: 0.25rem;
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgba(148, 0, 4, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(148, 0, 4, var(--tw-bg-opacity));
}
</style>
